<template>
  <div class="container">
    <div class="content">
      <h2>微信扫码联系客服</h2>
      <p style="margin: 50px auto;">
        <img src="/static/images/contact.jpg">
      </p>
      <h2>客服电话</h2>
      <div class="phone">
        400 088 3316
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = '医小智 - 联系客服';
  }
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-family: Arial, sans-serif;
  position: relative;
}

/* 设置内容区域的样式 */
.content {
  position: absolute;
  width: 500px;
  height: 700px;
  text-align: center;
  padding: 20px;
  background-color: #fff;
  h2{
    font-size: 30px;
    font-weight: 700;
    margin-top: 70px;
  }
  img{
    width: 200px;
    height: 200px;
  }
  .phone{
    font-size: 25px;
    margin: 50px auto;
  }
}
</style>



// WEBPACK FOOTER //
// contact.vue?20bebd56